export default __webpack_public_path__ + "static/0240-35e11ea5e7aff7889b21cdab0d3dfb17.png";